const REALM = 'backend';
const AUTH_BASE_URL = 'https://auth.psylaris.nl/auth/realms';

const ACC_API = 'https://api-acc-dot-turnkey-setup-246812.appspot.com/api';
const ACC_DEVICE_STREAM =
  'https://stream-device-server-acc-dot-turnkey-setup-246812.ew.r.appspot.com';
const ACC_MEDICAL_HYPNOSIS = `${ACC_DEVICE_STREAM}/product/medical_hypnosis`;
const ACC_EMDR_REMOTE = 'https://emdr-remote-acceptance.psylaris.nl';

const ENV_DEFAULTS = {
  production: {
    BASEURL: 'https://api.psylaris.nl/api',
    EMDR_REMOTE_PATH: 'https://emdr-remote.psylaris.nl',
    BASE_DEVICE_STREAM_URL:
      'https://stream-device-server-dot-turnkey-setup-246812.ew.r.appspot.com',
    MEDICAL_HYPNOSIS_PATH: undefined,
    EMERGIS_ORG_ID: 192,
  },
  local: {
    BASEURL: ACC_API,
    EMDR_REMOTE_PATH: 'https://emdr-remote-acceptance.psylaris.nl',
    BASE_DEVICE_STREAM_URL: ACC_DEVICE_STREAM,
    MEDICAL_HYPNOSIS_PATH: ACC_MEDICAL_HYPNOSIS,
    EMERGIS_ORG_ID: 71,
  },
  acceptance: {
    BASEURL: ACC_API,
    EMDR_REMOTE_PATH: ACC_EMDR_REMOTE,
    BASE_DEVICE_STREAM_URL: ACC_DEVICE_STREAM,
    MEDICAL_HYPNOSIS_PATH: ACC_MEDICAL_HYPNOSIS,
    EMERGIS_ORG_ID: 71,
  },
  integration: {
    BASEURL: 'https://integration-api.psylaris.nl/api',
    EMDR_REMOTE_PATH: 'https://emdr-remote-integration.psylaris.nl',
    BASE_DEVICE_STREAM_URL: ACC_DEVICE_STREAM,
    MEDICAL_HYPNOSIS_PATH: ACC_MEDICAL_HYPNOSIS,
    EMERGIS_ORG_ID: 71,
  },
};

const detectEnv = (origin) => {
  if (
    origin.includes('localhost:') ||
    origin.includes('ngrok-free.app') ||
    origin.includes('127.0.0.1')
  )
    return 'local';
  if (origin.includes('web-demo-dot-turnkey-setup-246812')) return 'acceptance';
  if (
    origin.includes('web-integration-dot-turnkey-setup-246812') ||
    origin.includes('integration.psylaris.nl')
  )
    return 'integration';
  return 'production';
};

const defaults = ENV_DEFAULTS[detectEnv(window.location.origin)];

const BASEURL = import.meta.env?.VITE_API_BASE_URL || defaults.BASEURL;
const EMDR_REMOTE_PATH =
  import.meta.env?.VITE_REMOTE_URL || defaults.EMDR_REMOTE_PATH;
const BASE_DEVICE_STREAM_URL =
  import.meta.env?.VITE_DEVICE_STREAM_URL || defaults.BASE_DEVICE_STREAM_URL;
const MEDICAL_HYPNOSIS_PATH =
  import.meta.env?.VITE_MEDICAL_HYPNOSIS_URL || defaults.MEDICAL_HYPNOSIS_PATH;
const EMERGIS_ORG_ID =
  import.meta.env?.VITE_EMERGIS_ORG_ID || defaults.EMERGIS_ORG_ID;

export const ANON_CLIENT_IDENTIFIER = '[QuickstartSessions] ';
export const EMDR_REMOTE_URL = EMDR_REMOTE_PATH;
export const MEDICAL_HYPNOSIS_URL = MEDICAL_HYPNOSIS_PATH;
export const CLIENT_PAGE = 'clientpage';
export const PRACTITIONER_PAGE = 'practitionerpage';
export const BASE_PRACTITIONER_URL = `${EMDR_REMOTE_URL}/${PRACTITIONER_PAGE}`;
export const THERAPY_ROOM = 'Therapy room';
export const REMOTE_THERAPY = 'Remote session';
export const MAX_TRIES = 120000;
export const INTERVAL_TIME_IN_MS = 3000;
export const EMAIL_REGEX =
  // eslint-disable-next-line max-len
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX =
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
export const DEVICE_STREAM_URL = BASE_DEVICE_STREAM_URL;
export const AUTH_URL = `${AUTH_BASE_URL}/${REALM}/protocol/openid-connect/auth`;
export const AUTH_SERVER_URL = AUTH_BASE_URL;
export const AUTH_REALM = REALM;
export const EMERGIS_ORGANIZATION_ID = EMERGIS_ORG_ID;
export const DEFAULT_FILTER_KEYS = [
  'isAnonymous',
  'limit',
  'order',
  'page',
  'searchQuery',
];
export default BASEURL;
